import { Component, OnInit, Input, HostListener, ElementRef, EventEmitter, Output } from '@angular/core';
import { Global } from '../classes/Global';
import { BaseComponent } from '../classes/BaseComponent';
import { DateHelper } from '../helpers/DateHelper';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent extends BaseComponent implements OnInit {

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      // Safely check className - handle cross-origin iframe elements
      let classNameString = '';
      try {
        const className = event.target.className;
        if (className) {
          if (typeof className === 'string') {
            classNameString = className;
          } else if (className && typeof className === 'object') {
            if (className.baseVal !== undefined) {
              classNameString = className.baseVal || '';
            } else if (typeof className.toString === 'function') {
              classNameString = className.toString();
            }
          }
        }
      } catch (e) {
        // Permission denied when accessing className from cross-origin iframe - ignore
        return;
      }
      //Click outside the drawer closes it
      if (classNameString != "burger-icon" && this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        this.open = false;
        this.onClose.emit();
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  @Input() open: boolean;
  @Output() onClose = new EventEmitter();

  constructor(private elementRef: ElementRef) {
    super();
  }

  ngOnInit() {
  }

  isBlackFriday(): boolean {
    return DateHelper.isBlackFriday();
  }

  getStoreUrl(): string {
    return Global.getStoreUrl();
  }

  getMediaType(): string {
    return Global.getMediaTypeForUrl();
  }

  getListsUrl(): string {
    return "/" + Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + this.getString("wishlistUrl");
  }

  getDiscoverUrl(): string {
    return "/" + [
      Global.getCountry(),
      Global.getStoreUrl(),
      Global.getMediaTypeForUrl(),
      this.getString("discoverUrl"),
      this.getString("editorialListsUrl")
    ].join("/");
  }

  isPersonalListsRouteActive(): boolean {
    return this.isRouteActive(this.getString("wishlistUrl")) ||
      this.isRouteActive(this.getString("myPurchasesUrl")) ||
      this.isRouteActive(this.getString("myListsUrl")) ||
      this.isRouteActive(this.getString("blocklistUrl"));
  }

  isPublicListsRouteActive(): boolean {
    return this.hasRouteSegment(this.getString("publicListsUrl")) ||
      this.hasRouteSegment(this.getString("communityListsUrl")) ||
      this.hasRouteSegment(this.getString("discoverUrl")) ||
      this.hasRouteSegment(this.getString("listsUrl"));
  }

  hasRouteSegment(segment: string): boolean {
    const path = location ? location.pathname.toString() : "";
    if (!path || !segment) {
      return false;
    }
    const routeSegments = path.split("/").filter((part) => part !== "");
    return routeSegments.indexOf(segment) > -1;
  }

}
